import Vue from 'vue'
import Router from 'vue-router'

const routerOptions = [
  { path: '/', component: 'Home' },
  { path: '/mentionlegale', component: 'Mentionlegale' },
  { path: '/contact', component: 'Contact' },
  { path: '/apropos', component: 'Apropos' },
  { path: '/publierjob', component: 'Publierjob' },
  { path: '/checkoutcancel', component: 'Checkoutcancel' },
  { path: '/checkoutsuccess', component: 'Checkoutsuccess' },
  { path: '/souscription/:id', component: 'Souscription' },
  { path: '/allemandcours/:id', component: 'Allemandcours' },
  { path: '*', component: 'NotFound' }
]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  }
})

Vue.use(Router)

export default new Router({
  routes,
  mode: 'history'
})




// WEBPACK FOOTER //
// ./src/router/index.js